import { HttpClient } from '@angular/common/http';
import { TranslateLoader } from '@ngx-translate/core';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import {PROJECT} from '../../../app/modules/shared/constants/link.constants';

export class CustomTranslateLoader implements TranslateLoader {
  constructor(
    private http: HttpClient,
    private s3BaseUrl: string,
    private fallbackPath: string,
    private isLocalhost: boolean = false
  ) {}

  getTranslation(lang: string): Observable<any> {
    const s3Url = this.isLocalhost
      ? `${this.s3BaseUrl}/assets/i18n/${lang}.json`
      : `${this.s3BaseUrl}/${PROJECT}/assets/i18n/${lang}.json`;

    const fallbackUrl = `${this.fallbackPath}/${lang}.json`;

    return this.http.get(s3Url).pipe(
      catchError((error) => {
        console.warn(`Fallback per lang ${lang}:`, error);
        return this.http.get(fallbackUrl).pipe(
          catchError((fallbackError) => {
            console.error(`Errore nel caricamento di entrambe le traduzioni per lang ${lang}:`, fallbackError);
            return of({});
          })
        );
      })
    );
  }
}
